import { useCallback } from "react";
import { workshopsAxios } from "./axios";

interface IWorkshopTypeTransfer {
  oldWorkshopType: string;
  newWorkshopType: string;
}

interface IWorkshopTypeTransferIds {
  oldWorkshopTypeIds: string[];
  newWorkshopType: string;
}

export const useTransferWorkshopType = () => {
  const [state, execute, cancel] = workshopsAxios<void, IWorkshopTypeTransfer | IWorkshopTypeTransferIds, unknown>(
    {
      url: "/transferWorkshopType",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IWorkshopTypeTransfer | IWorkshopTypeTransferIds) => {
      return execute({
        url: "/transferWorkshopType",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
